import { useEffect } from 'react'

/**
 * Отмечает на `<html>`, что пользователь пользуется КЛАВИАТУРОЙ.
 *
 * Зачем: списки поддерживают навигацию `j/k`, и у выбранной карточки есть
 * рамка-курсор. Раньше эта рамка висела на первой карточке с самой загрузки
 * страницы — выглядело как «что-то выделено, непонятно зачем и почему именно
 * это» (прямая жалоба со скриншотом). Показывать курсор до первого нажатия
 * клавиши незачем: мышью его никто не «двигает».
 *
 * Флаг ставится на Tab и на буквы навигации, снимается при первом же клике
 * мышью — вернулись к указателю, курсор списка снова лишний.
 */
const NAV_KEYS = new Set(['Tab', 'j', 'k', 'ArrowUp', 'ArrowDown'])

export function useKeyboardMode(): void {
  useEffect(() => {
    const root = document.documentElement

    const onKeyDown = (event: KeyboardEvent): void => {
      if (!NAV_KEYS.has(event.key)) return
      // Печать в поле — не навигация по списку.
      const target = event.target
      if (
        target instanceof HTMLInputElement ||
        target instanceof HTMLTextAreaElement ||
        (target instanceof HTMLElement && target.isContentEditable)
      ) {
        return
      }
      root.dataset.kbd = 'on'
    }

    const onPointerDown = (): void => {
      delete root.dataset.kbd
    }

    document.addEventListener('keydown', onKeyDown)
    document.addEventListener('pointerdown', onPointerDown)
    return () => {
      document.removeEventListener('keydown', onKeyDown)
      document.removeEventListener('pointerdown', onPointerDown)
    }
  }, [])
}
